import { Component, OnInit } from '@angular/core';
import { ConfigsService } from '@core/services/configs.service';
import { SynchronizationService } from '@core/services/synchronization.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  constructor(public configs: ConfigsService, private sync: SynchronizationService) { }

  public get loading(): boolean {
    return !this.sync.ready(ConfigsService);
  }

  ngOnInit(): void {    
  }
}
